import React, { useState, useEffect } from "react";
import Loader from "components/loader/Loader";
import { TextField } from "@mui/material";
import { searchUrlGroup } from "services/requests";

export default function SearchInput({
  text,
  onGroupSelection,
  onSearchChange,
}) {
  //STATE
  const [groups, setGroups] = useState([]);
  const [searchLoading, setSearchLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [loadedAllGroups, setLoadedAllGroups] = useState(false);
  //OTHERS
  const showSearchedGroups = text?.length > 0;

  useEffect(() => {
    let timeout = null;
    if (text?.length > 0) timeout = setTimeout(getGroups, 500);
    return () => clearTimeout(timeout);
  }, [text]);

  useEffect(() => {
    const elements = document.getElementsByClassName("searched-results");
    if (elements.length > 0) {
      let element = elements[0];
      element?.addEventListener("scroll", reachedTheBottom);
      return () => element?.removeEventListener("scroll", reachedTheBottom);
    }
  }, [showSearchedGroups, page, searchLoading]);

  /**
   * It searches for groups based in what the user wrote it in the search input
   */
  function getGroups() {
    setSearchLoading(true);
    searchUrlGroup(text, page)
      .then((data) => {
        handlePagination(data);
        setGroups([...groups, ...data?.results]);
      })
      .finally(() => setSearchLoading(false));
  }

  /**
   * @param {*} data
   * It checks if all groups were loaded, if not, increase page number in one
   */
  function handlePagination(data) {
    const loadedEverything = data?.results?.length < data?.pageSize;
    if (!loadedEverything) setPage(page + 1);
    setLoadedAllGroups(loadedEverything);
  }

  /** It's gonna call getGroups() again if user reaches
   * the bottom of the container and has more groups to load
   */
  function reachedTheBottom(event) {
    var element = event.target;
    const reachedBottom =
      element.scrollHeight - element.scrollTop === element.clientHeight;
    if (!searchLoading && reachedBottom && !loadedAllGroups) getGroups();
  }

  function renderGroup(item) {
    const { id, name } = { ...item };
    return (
      <div
        key={id}
        className="group-item"
        onClick={() => {
          onGroupSelection(item);
          setGroups([]);
          setPage(0);
        }}
      >
        <p>{name}</p>
      </div>
    );
  }

  return (
    <div className="search-input-container">
      <TextField
        label="Pesquisar grupo"
        type={"search"}
        onChange={(event) => {
          const { value } = { ...event?.target };
          onSearchChange(value);
          setGroups([]);
          setPage(0);
        }}
        size="small"
        fullWidth
        value={text}
      />
      {showSearchedGroups && (
        <div className="searched-results">
          {groups?.map((item, index) => renderGroup(item, index))}
          <Loader visible={searchLoading} width={30} />
          {!searchLoading && groups?.length === 0 && (
            <p className="no-data">Nenhum dado encontrado.</p>
          )}
        </div>
      )}
    </div>
  );
}
